import sizeTypes from "./constants/sizeTypes";

export default function translateVariantSize(sizeType, size, t) {
  switch(sizeType) {
    case sizeTypes.size_tu:
    case sizeTypes.size_multiple:
    case undefined:
      return t("common:unique_size");
    case sizeTypes.size_pants:
      return size;
    default:
      return t(`common:size_display_converter.${sizeType}.${size}`);
  }
}
